import {BuyBonusButtonView} from '@gongxigames/framework/slot/modules/buyBonus/buyBonusButton/BuyBonusButtonView';
import {KeypadView} from '@gongxigames/framework/slot/modules/keypad/KeypadView';
import {KeypadViewMobileLandscape} from '@gongxigames/framework/slot/modules/keypad/KeypadViewMobileLandscape';
import {Sprite} from 'pixi.js';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {DeviceType} from '@gongxigames/framework/core';

export class BuyBonusButtonViewLandscape extends BuyBonusButtonView {
    public static readonly NAME: symbol = Symbol('BuyBonusButtonViewLandscape');
    public static layer = LAYERS.KEYPAD;
    public static platform: DeviceType = DeviceType.MOBILE;

    protected get mainSprite(): Sprite {
        return this._installer.getComponent<KeypadView>(KeypadViewMobileLandscape.NAME).mainSprite;
    }
}
